import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DeviceStoreActions, DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Device } from '@rocksoft/shared';
import { DeviceOsUpdateContinueComponent } from './device-os-update-continue.component';
import { DeviceOsUpdateResetComponent } from './device-os-update-reset.component';

@Component({
  selector: 'era-device-os-update-action-bar',
  templateUrl: './device-os-update-action-bar.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceOsUpdateContinueComponent, DeviceOsUpdateResetComponent],
})
export class DeviceOsUpdateActionBarContainerComponent {
  private readonly store = inject(Store);

  readonly device = this.store.selectSignal(DeviceStoreSelectors.selectDeviceByCurrentAppleDevice);

  public reset(device: Device) {
    this.store.dispatch(DeviceStoreActions.DeviceSyncStatusViewActions.retryOsUpdate({ udid: device.udid }));
  }

  public continue(device: Device) {
    this.store.dispatch(DeviceStoreActions.DeviceSyncStatusViewActions.continueOsUpdate({ udid: device.udid }));
  }
}
